import * as React from 'react'

import type { CommonContractData } from 'modules/contracts/hooks/useFetchCommonContractData'
import type { FrenchContractData } from 'modules/contracts/hooks/useFetchFrenchContractData'
import type { GermanContractData } from 'modules/contracts/hooks/useFetchGermanContractData'
import type { SpanishContractData } from 'modules/contracts/hooks/useFetchSpanishContractData'

import { PortugueseContractData } from '../hooks/useFetchPortugueseContractData'

export interface LegalEntityContractData {
  loading: boolean
  frenchContractData: FrenchContractData
  germanContractData: GermanContractData
  spanishContractData: SpanishContractData
  portugueseContractData: PortugueseContractData
  commonContractData: CommonContractData
}

const Context = React.createContext<LegalEntityContractData | null | undefined>(null)

export const LegalEntityContractDataProvider = ({
  spanishContractData,
  frenchContractData,
  germanContractData,
  portugueseContractData,
  commonContractData,
  children,
}: {
  spanishContractData: SpanishContractData
  frenchContractData: FrenchContractData
  germanContractData: GermanContractData
  portugueseContractData: PortugueseContractData
  commonContractData: CommonContractData
  children: React.ReactNode
}) => {
  const loading =
    spanishContractData.loading ||
    frenchContractData.loading ||
    germanContractData.loading ||
    portugueseContractData.loading ||
    commonContractData.loading
  const contractData = {
    loading,
    frenchContractData,
    germanContractData,
    spanishContractData,
    portugueseContractData,
    commonContractData,
  }

  return <Context.Provider value={contractData}>{children}</Context.Provider>
}

export const useLegalEntityContractData = (): LegalEntityContractData => {
  const legalEntityContractData = React.useContext(Context)

  if (!legalEntityContractData) {
    throw new Error(
      'useLegalEntityContractData must be used within a LegalEntityContractDataProvider'
    )
  }

  return legalEntityContractData
}
